module.exports = __webpack_public_path__ + "img/1497319369.f6879abe.jpg";